/* PortalTableHead auto-generated by npm run generator */
import { makeStyles, TableCell, TableHead, TableRow, Theme } from "@material-ui/core"
import { observer } from "mobx-react"
import React from "react"

interface PortalTableHeadProps {
    headers: (string | JSX.Element)[]
}

const useStyles = makeStyles((theme: Theme) => ({
    header: {
        borderBottom: `2px solid ${theme.palette.secondary.dark}`,
    },
}))

const PortalTableHead: React.FC<PortalTableHeadProps> = ({ headers }) => {
    const classes = useStyles()

    return (
        <TableHead className={classes.header}>
            <TableRow>
                {headers.map((header) => (
                    <TableCell key={header.toString()} size="small">
                        {header}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

export default observer(PortalTableHead)
